// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_Ium","cls2":"common-cls2_XjD common-cls1_Ium","small":"common-small_Pj-","altLook":"common-altLook_yJc"};